module.exports = __webpack_public_path__ + "static/sharply-dressed-financial-advisor.04239431.webp";